import { useState } from "react";
import { RegistrationGroup } from "../../api/getEventTransactionDetails/types";
import { Loader2 } from "lucide-react";
import { RegistrationCard } from "./RegistrationCard";
import { RegistrationDrawer } from "./RegistrationDrawer";

interface TransactionsViewProps {
  registrationGroups: RegistrationGroup[];
  isLoading: boolean;
  onRefundSuccess: () => void;
}

export function TransactionsView({
  registrationGroups,
  isLoading,
  onRefundSuccess,
}: TransactionsViewProps) {
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null);

  const selectedGroup = registrationGroups.find(
    (g) => g.id === selectedGroupId,
  ) ?? null;

  function handleSelect(group: RegistrationGroup) {
    setSelectedGroupId(group.id);
  }

  function handleClose() {
    setSelectedGroupId(null);
  }

  function handleRefundSuccess() {
    onRefundSuccess();
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (registrationGroups.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-gray-500 dark:text-gray-400">
          No transactions found for this session.
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="space-y-2">
        {registrationGroups.map((group) => (
          <RegistrationCard
            group={group}
            key={group.id}
            onClick={() => handleSelect(group)}
          />
        ))}
      </div>

      <RegistrationDrawer
        group={selectedGroup}
        onClose={handleClose}
        onRefundSuccess={handleRefundSuccess}
        open={!!selectedGroup}
      />
    </>
  );
}
